module.exports = __webpack_public_path__ + "fonts/scoreFont.2d5c612e.otf";